import { Component, OnInit } from '@angular/core';
import { BuyService } from '../../../services/buyservice'
@Component({
  selector: 'app-dashbroad',
  templateUrl: './dashbroad.component.html',
  styleUrls: ['./dashbroad.component.css']
})
export class DashbroadComponent implements OnInit {

  length;
  constructor(public buy: BuyService) { }

  ngOnInit() {
    let dataItem = this.buy.getOrder()
    dataItem.subscribe((snap) => {
      this.length = snap.length
    })
  }
  
}



// WEBPACK FOOTER //
// D:/pokpak-v3/pokpak-v2/pokpak-ang/src/app/admin/page/dashbroad/dashbroad.component.ts